import { render, staticRenderFns } from "./extract_detail.vue?vue&type=template&id=19978124&scoped=true"
import script from "./extract_detail.vue?vue&type=script&lang=js"
export * from "./extract_detail.vue?vue&type=script&lang=js"
import style0 from "./extract_detail.vue?vue&type=style&index=0&id=19978124&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19978124",
  null
  
)

export default component.exports